import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DocsDigitalTabla } from "../gen/siniestros/DocsDigitalTabla";
import { useParams } from "react-router-dom";
import { routes } from "../gen/General";
import axios from "axios";

export const CltDocumento = () => {
    const user = useSelector(state => state.user);
    const [open, setOpen] = useState(false);
    let { id } = useParams();
    let docminio = useState([]);
    const [docdigital, setdocdigital] = useState([]);
    const dato = id || user.cdCliente;
    console.log(dato);

    const onClose = () => {
        fetchData();
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios
            .get(routes.api + "/docs", {
                params: {
                    tipo: "vinculacion",
                    cdCliente: id || user.cdCliente,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                setdocdigital(res);
                //this.setState({docdigital: res});
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    return (
        <DocsDigitalTabla
            docdigital={docdigital}
            docminio={docminio}
            tipo={"vinculacion"}
            dato={dato}
            vinculacion={true}
            onClose={onClose}
        />
    );
};
